import { Directive, forwardRef } from '@angular/core'
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms'

@Directive({
  selector: '[appNumberPositiveInteger][ngModel],[appNumberPositiveInteger][formControl]',
  providers: [{
    provide: NG_VALIDATORS, multi: true,
    useExisting: forwardRef(() => NumberPositiveIntegerValidator),
  }],
})
export class NumberPositiveIntegerValidator implements Validator {

  validate(control: AbstractControl) {
     if (control.value === null || control.value == null ) {
      return null
     }

     if (control.value < 0 ) {
       return { numeroInvalido: { valor: 'No puede ser un valor negativo'} }
     }

     if ( !(control.value % 1 === 0)  ) {
        return { numeroInvalido: {valor: 'No puede ser un valor con decimales'}}
     }

     if ( control.value < 1 ) {
        return { numeroInvalido: {valor: 'El valor no puede ser menor a 1'}}     }

     return null
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/number-positive-integer.validator.ts